import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Layout from 'src/app/components/Layout/Layout';
import LayoutLeftColumn from 'src/app/components/Layout/LayoutLeftColumn';
import LayoutRightColumn from 'src/app/components/Layout/LayoutRightColumn';
import { askForOffersAmount } from 'src/app/redux/actions/offers';
import 'src/app/components/Layout/LayoutOffersCount.scss';


class LayoutOffersCount extends React.Component {

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(askForOffersAmount());
  }

  render() {
    const { offers, background, children } = this.props;
    return (
      <Layout>
        <LayoutLeftColumn>
          {children}
        </LayoutLeftColumn>

        <LayoutRightColumn background={ background }>
          <h1 styleName="welcome__headline">Nowa praca?</h1>
          <h2 styleName="welcome__subline">Jesteś w dobrym miejscu</h2>
          {
            !!offers &&
            <h3 styleName="welcome__description">Nowa praca? <strong>{offers} ofert</strong> od najlepszych
              pracodawców</h3>
          }
        </LayoutRightColumn>
      </Layout>
    );
  }
}

LayoutOffersCount.propTypes = {
  offers: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  dispatch: PropTypes.func.isRequired,
  background: PropTypes.shape({
    preSrc: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired
  }).isRequired
};

const mapStateToProps = (store) => ({
  offers: store.offersReducer.amount
});

export default connect(mapStateToProps)(LayoutOffersCount);
